import React, { PropTypes, Component } from 'react'
import acc from 'accounting'

class ListSubjectItem extends Component {

  _renderRequisites(subject) {
    let pre = subject.get('prereq').map((s) => s.get('code')).toJS()
    let co = subject.get('coreq').map((s) => s.get('code')).toJS()

    pre = pre.join(', ')
    co = co.join(', ')
    co = co ? ' / ' + co : co
    return (
      <div><small>{pre}{co}</small></div>
    )
  }

  render() {
    const { subject } = this.props
    const inGPA = subject.get('is_in_gpa')
    let cl = ''
    let mt = ''
    let ft = ''
    let fg = ''
    let re = ''

    const lecUnits = acc.formatNumber(subject.get('lec_units'), 1)
    const labUnits = acc.formatNumber(subject.get('lab_units'), 1)
    const units = acc.formatNumber(subject.get('units'), 1)

    const lec = inGPA ? lecUnits : `(${lecUnits})`
    const lab = inGPA ? labUnits : `(${labUnits})`
    const unit = inGPA ? units : `(${units})`

    if (subject.getIn(['grades', 'id'])) {
      if (subject.getIn(['grades', 'action']) === 1) {
        cl = 'info'
      }
      if (subject.getIn(['grades', 'is_grade_approved'])) {
        cl = subject.getIn(['grades', 'passed']) ? 'success' : 'danger'
        mt = subject.getIn(['grades', 'mt'])
        ft = subject.getIn(['grades', 'ft'])
        fg = subject.getIn(['grades', 'fg'])
        re = subject.getIn(['grades', 're'])
      }
    }

    return (
      <tr className={cl}>
        <td><code>{subject.get('code')}</code></td>
        <td>{subject.get('name')}</td>
        <td className="text-right">{lec}</td>
        <td className="text-right">{lab}</td>
        <td className="text-right"><strong>{unit}</strong></td>
        <td>{this._renderRequisites(subject)}</td>
        <td className="text-right"><strong>{mt}</strong></td>
        <td className="text-right"><strong>{ft}</strong></td>
        <td className="text-right"><strong>{fg}</strong></td>
        <td className="text-right"><strong>{re}</strong></td>
      </tr>
    )
  }
}

ListSubjectItem.propTypes = {
  subject: PropTypes.object,
}

export default ListSubjectItem



// WEBPACK FOOTER //
// ./src/containers/Curriculum/list-subject-item.js